import CompanyQuoteMenu from './CompanyQuoteMenu'
// Uncomment the below to migrate to stateful component
// import CompanyQuoteMenuContainer from './CompanyQuoteMenuContainer'

export { CompanyQuoteMenu }
export default CompanyQuoteMenu
// Uncomment the below to migrate to stateful component
// export { CompanyQuoteMenuContainer }
// export default { CompanyQuoteMenuContainer }
